import { render, staticRenderFns } from "./NavShell.vue?vue&type=template&id=6e7b05d4"
import script from "./NavShell.vue?vue&type=script&lang=js"
export * from "./NavShell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports